import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/facebook-messenger': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224.5 32c126.5 0 223.5 92.4 223.5 217.3 0 158.2-150.1 246.8-288.5 208.7-8.1-2.2-8.7-0.5-56.5 20.5-1.9 0.8-5.1 1.5-7.2 1.5-9.6 0-17.7-7.8-18-17.4-1.3-41.9 0.3-45.8-7.3-52.6-43.7-39-70.5-95.4-70.5-160.7 0-124.8 98-217.3 224.5-217.3zM359.3 199.2c6.4-10-6-21.3-15.4-14.1l-70.8 53.6c-2 1.5-5.6 2.7-8.1 2.7s-6.1-1.2-8.1-2.7l-52.4-39.3c-5-3.7-14-6.7-20.2-6.7-10.3 0-23 7-28.5 15.7l-66 104.4c-6.4 10 6 21.3 15.5 14.2l70.8-53.6c2-1.5 5.6-2.7 8.1-2.7 2.5 0 6.1 1.2 8.1 2.7l52.4 39.3c5 3.7 14 6.7 20.2 6.7 10.3 0 23-7 28.5-15.7z'
      }
    ]
  }
})
